<div [formGroup]="control" class="h-100 flex-row-wrap flex-align-space-between-center">
	<app-input-color formControlName="primary" class="flex-48" [label]="'culoare.primara' | translate"></app-input-color>

	<app-input-color
		formControlName="secondary"
		class="flex-48"
		[label]="'culoare.secundara' | translate"
	></app-input-color>

	<app-input-color formControlName="other" class="flex-48" [label]="'culoare.tertiara' | translate"></app-input-color>

	<app-input-color formControlName="background" class="flex-48" [label]="'obiect.fundal' | translate"></app-input-color>

	<mat-checkbox color="primary" class="rounded-checkbox flex-48" formControlName="hidePrice">{{
		"actiune.ascundePret" | translate
	}}</mat-checkbox>

	<div class="flex-100 custom-hr"></div>

	<div class="flex-100 flex-row-nowrap" style="margin-top: 10px; margin-bottom: 10px">
		<div class="flex-50 flex-column-nowrap">
			<p>{{ "upload.logo" | translate }}</p>
			<input (change)="selectFile($event, 'logoUrl1')" type="file" />
			<div *ngIf="message && currentField == 'logoUrl1'" class="msgupload">{{ message }}</div>
		</div>
		<span class="flex-10"></span>
		<div class="flex-40">
			<img *ngIf="imgUrl1_temp" [src]="imgUrl1_temp" class="imgupload" />

			<ng-container *ngIf="!imgUrl1_temp">
				<img *ngIf="logoUrl1$ | async as url" [src]="url" class="imgupload" />
			</ng-container>
		</div>
	</div>

	<div class="flex-100 custom-hr"></div>

	<div class="flex-100 flex-row-nowrap" style="margin-top: 10px; margin-bottom: 10px">
		<div class="flex-50 flex-column-nowrap">
			<p>{{ "upload.coperta" | translate }}</p>
			<input (change)="selectFile($event, 'logoUrl2')" type="file" />
			<div *ngIf="message && currentField == 'logoUrl2'" class="msgupload">{{ message }}</div>
		</div>
		<span class="flex-10"></span>
		<div class="flex-40">
			<img *ngIf="imgUrl2_temp" [src]="imgUrl2_temp" class="imgupload" />

			<ng-container *ngIf="!imgUrl2_temp">
				<img *ngIf="logoUrl2$ | async as url" [src]="url" class="imgupload" />
			</ng-container>
		</div>
	</div>

	<div class="flex-100 custom-hr"></div>

	<div class="flex-100 flex-row-wrap flex-align-space-between-center" style="margin-top: 10px; margin-bottom: 10px">
		<p class="flex-100">Footer</p>
		<app-input formControlName="ownerCompany" class="flex-48" [label]="'obiect.nume' | translate"></app-input>
		<app-input formControlName="ownerEmail" class="flex-48" label="Email"></app-input>
		<app-input formControlName="ownerPhone" class="flex-48" [label]="'obiect.telefon' | translate"></app-input>
	</div>
</div>
